import { ReactComponent as B15p } from './15plus.svg';
import { ReactComponent as B14p } from './14plus.svg';
import { ReactComponent as B2 } from './2B.svg';
import { ReactComponent as B3 } from './3B.svg';
import { ReactComponent as B4 } from './4B.svg';
import { ReactComponent as B5 } from './5B.svg';
import { ReactComponent as B6 } from './6B.svg';
import { ReactComponent as B7 } from './7B.svg';
import { ReactComponent as B8 } from './8B.svg';
import { ReactComponent as B9 } from './9B.svg';
import { ReactComponent as B10 } from './10B.svg';
import { ReactComponent as B11 } from './11B.svg';
import { ReactComponent as B12 } from './12B.svg';
import { ReactComponent as B13 } from './13B.svg';
import { ReactComponent as B14 } from './14B.svg';
import { ReactComponent as B15 } from './15B.svg';

export default [B15p, B14p, B2, B3, B4, B5, B6, B7, B8, B9, B10, B11, B12, B13, B14, B15];
